/**
 * Lấy lý do lỗi người dùng đọc được từ phản hồi API. Hỗ trợ `{ message }` của các service và
 * `ValidationProblemDetails` của ASP.NET (`{ errors: { Field: ["..."] } }`, 400 trước khi vào action).
 * Không có gì dùng được thì trả `fallback`.
 */
export const apiErrorMessage = (err: unknown, fallback: string): string => {
  const data = (err as { response?: { data?: any } })?.response?.data;
  if (typeof data?.message === 'string' && data.message.trim()) return data.message;
  const errors = data?.errors;
  if (errors && typeof errors === 'object') {
    const first = Object.values(errors).flat().find((m) => typeof m === 'string' && m.trim());
    if (first) return `${fallback}: ${first}`;
  }
  return fallback;
};
